import { render, staticRenderFns } from "./FlowPostToConversation.vue?vue&type=template&id=fabe55a6&scoped=true"
import script from "./FlowPostToConversation.vue?vue&type=script&lang=js"
export * from "./FlowPostToConversation.vue?vue&type=script&lang=js"
import style0 from "./FlowPostToConversation.vue?vue&type=style&index=0&id=fabe55a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabe55a6",
  null
  
)

export default component.exports